import { SortColorsBy } from '../common/constants';

export const colorSortOptions = [
  {
    value: SortColorsBy.NameAsc,
    label: 'Name A - Z',
  },
  {
    value: SortColorsBy.NameDesc,
    label: 'Name Z - A',
  },
  {
    value: SortColorsBy.PriceDesc,
    label: 'Price High to Low',
  },
  {
    value: SortColorsBy.PriceAsc,
    label: 'Price Low to High',
  },
  {
    value: SortColorsBy.Featured,
    label: 'Featured',
  },
];
